// File: apps/web/src/routes/import.tsx
// Version: 2026.4.7 | Sprint 7 Wave 3 — Import route
//
// Thin route wrapper. All the logic lives in features/import/ImportPage.

import { createFileRoute } from '@tanstack/react-router';
import { ImportPage } from '../features/import/ImportPage';

export const Route = createFileRoute('/import')({
  component: ImportPage,
});
